import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import CreateForm from './create';
import { useTranslation } from "react-i18next";
import { Drawer, Button, Switch } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";
import { actions as stkActions } from '../../../../../store/reducers/stakeholder';
import DynamicView from "../../../../../components/DynamicViewNew";
import { EditOutlined } from "@ant-design/icons";
import { displayMessage } from "../../../../../helpers/Messages";
import styled from 'styled-components';
import PageHeader from "../../../../../components/Layout/PageHeader";
import { DrawerHeader } from "datastake-daf/dist/components";
import { CREATE_DRAWER_WIDTH } from "../../../../../helpers/form";

const Styles = styled.div`
	.ant-page-header {
		padding: 8px 8px 8px var(--size);
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		.ant-page-header-back-button {
			color: var(--mmt-primary-70)
		}
		.ant-page-header-heading {
			justify-content: flex-start;
		}
		.ant-page-header-heading-left {
			margin-top: 0;
		}
		.ant-page-header-heading-title {
			line-height: 22px;
			margin-top: 4px;
		}
		.ant-page-header-heading-extra {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			flex-grow: 1;
			margin: 0 var(--size);
		}
		.ant-btn {
			display: flex;
			span[role="img"] {
				font-size: 18px;
			}
		}
	}
	.ant-descriptions {
		padding: var(--size)
	}
	.ant-descriptions:not(.project) {
		width: 100%;
		// width: calc(100% / 2);
		padding-bottom: 0;
		.ant-descriptions-title {
			font-size: 14px;
			font-weight: 500;
		}
		&:nth-of-type(1) {
			.ant-descriptions-title {
				opacity: 0;
			}
		}
	}
	.ant-descriptions-item {
		padding-bottom: 6px;
		.ant-descriptions-item-label {
			font-weight: 500
		}
	}
	.ant-col{
		padding: 0px 5px;
	}
	/* #tab-1 {
		margin-left: var(--size);
	} */
  .view-toggle {
    width: 80px;
  }
`;

const mstp = ({ authentication, stakeholder }) => ({
  authentication,
  stakeholder
});
function ProfilePME({
  stakeholder: { data: profileData },
  namespace = 'Stakeholder',
  module = 'pme',
  view = 'identification',
  stakeholderDataGet,
  authentication: {
    user,
  }
}) {
  const [isTabsView, setTabsView] = useState(StorageManager.get('datastake-view-mode') === 'section');
  const [activeFormIndex, setActiveFormIndex] = useState('');
  const identification = profileData['pme-identification'];

  const { form = {}, data = {}, config = { disabledInputs: [] } } = identification || { data: {}, form: {} };
  const location = useLocation();
  const goTo = useNavigate();

  const [editVisible, setEditVisible] = useState(location.search.indexOf('create') !== -1);
  const { t } = useTranslation();


  useEffect(() => {
    if (!identification || !identification.data || !identification.form) {
      stakeholderDataGet({ namespace, module, view });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identification]);

  const formView = JSON.parse(JSON.stringify(form));
  let formViewData = JSON.parse(JSON.stringify(data));
  formViewData = {
    dsUserId: user.userId,
    mStatus: user.modules && user.modules.pme ? [user.modules.pme.status] : [],
    ...formViewData
  };

  const excludedKeys = [
    'positionInTheMineralSupplyChain',
    'rolesInTheMineralSupplyChain'
  ];

  if (formViewData.category === 'individual') {
    excludedKeys.push(
      'dueDiligenceRole',
      'fullName',
      'organisationName',
      'country',
      'countryOfIncorporation',
      'website',
      'emailAddress'
    )
  }
  return (
    <Styles className="semibold form-input-output" style={{ height: '100%' }}>
      <PageHeader
        title={t("User Information")}
        extra={[
          <Button
            type="link"
            key="1"
            icon={<EditOutlined />}
            onClick={() => setEditVisible(true)}>
            {t("EDIT")}
          </Button>,
          <div
            key="2"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <p style={{ margin: '0 12px 0 0' }}><strong>{t("View")}:</strong></p>

            <Switch
              checkedChildren={t("Sections")}
              unCheckedChildren={t("Full")}
              checked={isTabsView}
              onChange={(checked) => {
                if (checked) {
                  StorageManager.set('datastake-view-mode', 'section');
                } else {
                  StorageManager.set('datastake-view-mode', 'full');
                }
                setTabsView(checked)
              }}
              className="view-toggle"
            />
          </div>
        ]} />
      {form ? (
        <DynamicView
          form={formView}
          data={formViewData}
          excludeKeys={excludedKeys}
          setEditVisible={(ind) => {
            setActiveFormIndex(ind);
            setEditVisible(true);
          }}
          onTabChange={(ind) => setActiveFormIndex(ind)}
          tabs={isTabsView}
        />
      ) : null}
      <Drawer
        destroyOnClose={true}
        title={<DrawerHeader title={t("User Information")} />}
        open={editVisible}
        maskClosable={false}
        onClose={() => {
          setEditVisible(false)
          goTo('/app/pme/profile')
        }}
        width={CREATE_DRAWER_WIDTH}
        bodyStyle={{ padding: 0 }}>
        <CreateForm
          disabledInputs={['dsUserId', 'mStatus', ...(config.disabledInputs || [])]}
          formValue={data}
          onSubmitted={(type, m) => displayMessage(type, m)}
          formOptions={form}
          onCancel={() => setEditVisible(false)}
          activeFormIndex={activeFormIndex}
        />
      </Drawer>
    </Styles>
  )
}


export default connect(mstp, stkActions)(ProfilePME);